import styled from "styled-components";
import media from "styled-media-query";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 96px;
`;

export const Title = styled.h2`
  color: #fff;
  font-family: Sora;
  font-size: 32px;
  font-weight: 700;
  line-height: 48px;
  text-transform: uppercase;
`;

export const Container = styled.div`
  align-items: center;
  display: grid;
  grid-gap: 60px;
  grid-template-columns: 1fr 1fr;

  img {
    height: 400px;
    max-width: 500px;
    width: 100%;
    object-fit: contain;

    ${media.lessThan("medium")`
    height: 280px;
    `}
  }

  p {
    color: #fff;
    font-family: Sora;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
  }

  ${media.lessThan("medium")`
  grid-gap: 40px;
  grid-template-columns: 1fr;
  `}
`;

export const Form = styled.div`
  display: grid;
  grid-gap: 17px;
  grid-template-columns: 1fr;

  h2 {
    color: #fff;
    font-family: Sora;
    font-size: 24px;
    font-weight: 700;
    line-height: 36px;
    text-transform: uppercase;
  }
`;

export const InputWrapper = styled.div`
  display: grid;
  grid-gap: 24px;
  grid-template-columns: 1fr 1fr;

  ${media.lessThan("medium")`
  grid-gap: 17px;
  grid-template-columns: 1fr;
`}
`;

export const SendWrapper = styled.div`
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  gap: 17px;

  button {
    align-items: center;
    background-color: #ff520b;
    color: #fff;
    display: flex;
    font-family: Sora;
    font-size: 14px;
    font-weight: 700;
    gap: 4px;
    justify-content: center;
    line-height: 24px;
    padding: 4px 24px;
    width: 168px;
  }

  span {
    color: #fff;
    text-align: right;
    font-family: Sora;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;

    ${media.lessThan("medium")`
      max-width: 200px;
    `}
  }
`;
